import ProfileAPI from '../model/API/profile';
 

const mock: ProfileAPI =  
    {
    "magic":475836,
    "questsstarted":3,
    "totalskill":1582,
    "questscomplete":75,
    "questsnotstarted":216,
    "totalxp":44082405,
    "ranged":1417954,
    "activities":[
        {"date":"01-Aug-2015 20:01","details":"I levelled my  Construction skill, I am now level 57.","text":"Levelled up Construction."},
        {"date":"01-Aug-2015 19:31","details":"I levelled my  Prayer skill, I am now level 65.","text":"Levelled up Prayer."},
        {"date":"01-Aug-2015 19:28","details":"I levelled my  Summoning skill, I am now level 59.","text":"Levelled up Summoning."},
        {"date":"01-Aug-2015 19:12","details":"I levelled my  Construction skill, I am now level 54.","text":"Levelled up Construction."},
        {"date":"30-Jul-2015 02:21","details":"I levelled my  Construction skill, I am now level 53.","text":"Levelled up Construction."},
        {"date":"29-Jul-2015 02:24","details":"I killed 4 King Black Dragons, which were once the biggest, meanest dragons around.","text":"I killed 4 King Black Dragons."},
        {"date":"29-Jul-2015 01:58","details":"I killed  the King Black Dragon, which was once the biggest, meanest dragon around.","text":"I killed  the King Black Dragon."}],
        "skillvalues":[
            {"level":99,"xp":131750511,"id":11},
            {"level":99,"xp":130681269,"id":7},
            {"level":92,"xp":68310414,"id":6},
            {"level":77,"xp":15266488,"id":14},
            {"level":76,"xp":14179543,"id":3},
            {"level":76,"xp":13466410,"id":0},
            {"level":75,"xp":12999548,"id":2},
            {"level":75,"xp":12153725,"id":1},
            {"level":72,"xp":9797129,"id":21},
            {"level":67,"xp":5709116,"id":16},
            {"level":66,"xp":5118859,"id":13},
            {"level":65,"xp":4758360,"id":5},
            {"level":60,"xp":3001704,"id":4},
            {"level":59,"xp":2686767,"id":23},
            {"level":57,"xp":2197276,"id":22},
            {"level":55,"xp":1800097,"id":17},
            {"level":53,"xp":1373649,"id":10},
            {"level":50,"xp":1036518,"id":12},
            {"level":50,"xp":1026549,"id":8},
            {"level":50,"xp":1019061,"id":20},
            {"level":48,"xp":883361,"id":18},
            {"level":47,"xp":796994,"id":9},
            {"level":40,"xp":407089,"id":15},
            {"level":37,"xp":297436,"id":24},
            {"level":27,"xp":97628,"id":19},
            {"level":8,"xp":8698,"id":25},
            {"level":1,"xp":0,"id":27},
            {"level":1,"xp":0,"id":26}
        ],
            "name":"AndreArmadyl",
            "melee":22648888,
            "combatlevel":112,
            "loggedIn":false
}

export default mock;